import 'swiper/swiper-bundle.css'
import { RequiredDeep } from 'vtils/types'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import type { SwiperOptions } from 'swiper'

export const XSwiper = Swiper
export const XSwiperItem = SwiperSlide

export function defineSwiperOptions(
  options: SwiperOptions & {
    /** 在幻灯片内可滑动 */
    scrollInSlide?: boolean
    onInit?: RequiredDeep<SwiperOptions['on']>['init']
    onChange?: RequiredDeep<SwiperOptions['on']>['slideChange']
  },
): SwiperOptions {
  return {
    ...options,
    on: {
      ...options.on,
      init: swiper => {
        if (options.scrollInSlide) {
          // https://github.com/nolimits4web/swiper/issues/1467#issuecomment-150010090
          let startScroll: any, touchStart: any, touchCurrent: any
          swiper.slides.on(
            'touchstart',
            function (this: any, e: any) {
              startScroll = this.scrollTop
              touchStart = e.targetTouches[0].pageY
            },
            true,
          )
          swiper.slides.on(
            'touchmove',
            function (this: any, e: any) {
              touchCurrent = e.targetTouches[0].pageY
              const touchesDiff = touchCurrent - touchStart
              const onlyScrolling =
                this.scrollHeight > this.offsetHeight && //allow only when slide is scrollable
                ((touchesDiff < 0 && startScroll === 0) || //start from top edge to scroll bottom
                  (touchesDiff > 0 &&
                    startScroll === this.scrollHeight - this.offsetHeight) || //start from bottom edge to scroll top
                  (startScroll > 0 &&
                    startScroll < this.scrollHeight - this.offsetHeight)) //start from the middle
              if (onlyScrolling) {
                e.stopPropagation()
              }
            },
            true,
          )
        }

        if (options.onInit) {
          options.onInit(swiper)
        }

        if (options.onChange) {
          swiper.on('slideChange', options.onChange)
        }

        options.on?.init?.(swiper)
      },
    },
  }
}
